// Code is copied and simplified from https://github.com/bryanwoods/autolink-js/blob/master/autolink.js
const URL_PATTERN =
  // eslint-disable-next-line sonarjs/duplicates-in-character-class -- Disabled for plugin version update. Fix when possible.
  /(^|[\s\n]|<[A-Za-z]*\/?>)((?:https?|ftp):\/\/[-A-Z0-9+\u0026\u2019@#/%?=()~_|!:,.;]*[-A-Z0-9+\u0026@#/%=~()_|])/gi;

export const autolink = function (content: string) {
  try {
    return content.replace(
      URL_PATTERN,
      function (_match: string, space: string, url: string) {
        return `${space}<a class="break-all" href='${url}' target='_blank' rel='noopener noreferrer'>${url}</a>`;
      },
    );
  } catch {
    return content;
  }
};
